module.exports = __webpack_public_path__ + "static/media/money-bag.db2ab6c4.svg";